<template>
  <div class="cateringdetail">
    <topNav :title="$t('cateringDetail_title')"
            selfMethod="1"
            @leftClick="goBack"></topNav>
    <div class="caterTop">
      <p class="left">{{$t('cateringOrder_accnt')}}: <span>{{order.accnt}}</span></p>
      <p class="right">{{$t('orderDetail_sta')}}：<span>{{order.sta}}</span></p>
    </div>
    <div class="infoList">
      <div class="info">
        <div class="infoTop">
          <i class="iconfont icon-changfangxingbiaoqian"></i>
          {{$t('cateringDetail_venue_info')}}
        </div>
        <ul class="infoContent clearfix ">
          <li>{{$t('cateringDetail_hotelCode')}}:<span class="infoVal">{{order.hotelCode}}</span></li>
          <li>{{$t('cateringOrder_resName')}}:<span class="infoVal">{{order.resName}}</span></li>
          <li>
            {{$t('cateringDetail_shiftDes')}}:<span class="infoVal">{{order.bizDate | dateF}} {{order. shiftDes}}</span>
          </li>
          <li>{{$t('cateringDetail_pccodeDes')}}:<span class="infoVal">{{order.pccodeDes}}</span></li>
          <li>{{$t('cateringDetail_type1Des')}}:<span class="infoVal">{{order.type1Des}}</span></li>
          <li class="twocol">{{$t('cateringDetail_tablenoDes')}}:<span class="infoVal">{{order.tablenoDes}} {{order.tableTypeDes}}</span>
          </li>
          <li class="twocol">{{$t('cateringDetail_exttableno')}}:<span class="infoVal">{{order.exttableno}}</span></li>
        </ul>
      </div>
      <div class="info">
        <div class="infoTop">
          <i class="iconfont icon-changfangxingbiaoqian"></i>
          {{$t('cateringDetail_res_info')}}
        </div>
        <ul class="infoContent clearfix">
          <!--<li>餐单类别:<span class="infoVal">{{order.hotelCode}}</span></li>-->
          <li class="twocol">
            {{$t('cateringDetail_amount')}}:<span class="infoVal">{{order.amount}} / {{order.typeDes}}</span></li>

          <li class="twocol">{{$t('cateringDetail_numb')}}:<span class="infoVal">{{order.numb | intF}}</span></li>

          <li class="twocol">{{$t('cateringOrder_gsts')}} :<span class="infoVal">{{order.gsts}}</span></li>
          <li class="twocol"> {{$t('cateringDetail_beginTime')}}:<span class="infoVal">{{order.beginTime}}</span></li>
          <li class="twocol">{{$t('cateringDetail_modeDes')}}:<span class="infoVal">{{order.modeDes}}</span></li>
          <li class="twocol">{{$t('cateringDetail_endTime')}}:<span class="infoVal">{{order.endTime}}</span></li>

          <li class="twocol">{{$t('cateringDetail_pay')}}:<span class="infoVal">{{order.pay}}</span></li>
          <li class="twocol">{{$t('cateringDetail_payTypeDes')}}:<span class="infoVal">{{order.payTypeDes}}</span></li>
          <li style="clear:both;height:auto;">{{$t('cateringDetail_info')}}:<span class="infoVal">{{order.info}}</span>
          </li>
        </ul>
      </div>
      <div class="info">
        <div class="infoTop">
          <i class="iconfont icon-changfangxingbiaoqian"></i>

          {{$t('cateringDetail_con_info')}}
        </div>
        <ul class="infoContent clearfix "
            style="border-bottom: none">
          <li class="twocol"> {{$t('cateringDetail_linkMan')}}:<span class="infoVal">{{order.linkMan}}</span></li>
          <li class="twocol"> {{$t('cateringDetail_phone')}}:<span class="infoVal"><a :href='"tel:"+order.phone'>{{order.phone}}</a></span>
          </li>
          <li class="twocol">{{$t('cateringDetail_haccntName')}}:<span class="infoVal">{{order.haccntName}}</span></li>
          <li class="twocol"
              style="clear:both;width: 100%;">{{$t('cateringDetail_love')}}:<span class="infoVal">{{order.love}}</span></li>
          <li class="twocol"
              style="clear:both;width: 100%;">{{$t('cateringDetail_cusinfo')}}:<span class="infoVal">{{order.cusinfo}}</span></li>
          <li class="twocol"
              style="clear:both;width: 100%;">{{$t('cateringDetail_cardNo')}}:<span class="infoVal">{{order.cardNo}}</span></li>
          <li class="twocol"
              style="clear:both;width: 100%;">{{$t('cateringDetail_cardName')}}:<span class="infoVal">{{order.cardName}}</span></li>
          <li class="twocol"
              style="clear:both;width: 100%;">{{$t('cateringDetail_saleInfo')}}:<span class="infoVal">{{order.saleInfo}}</span></li>
          <li class="twocol"
              style="clear:both;width: 100%;">{{$t('cateringDetail_marketDes')}}:<span class="infoVal">{{order.marketDes}}</span></li>
          <li class="twocol"
              style="clear:both;width: 100%;">{{$t('cateringDetail_sourceDes')}}:<span class="infoVal">{{order.sourceDes}}</span></li>
        </ul>
      </div>

      <!--&lt;!&ndash;X是取消的状态&ndash;&gt;           -->

      <div class='btn-fixed-bottom'
           v-if='order.sta !=="X"'
           @click='confirmCancel'>{{$t('cancel')}}
      </div>
    </div>

  </div>
</template>
<script>
  import {Toast,MessageBox} from "mint-ui";
  import moment from "moment";

  export default {
    data() {
      return {
        order: {}
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      goBack(){
        this.$router.go(-1);
      },
      confirmCancel(){
        MessageBox.confirm(this.$t('cateringDetail_cancel_confirm'))
          .then(() => {
            this.doCancel()
          }).catch(() => {})
      },
      doCancel() {
        this.$http
          .post("/mobilepmsapi/pos/cancelResOrder", {
            accnt: this.$route.query.id
          })
          .then(res => {
            if (res.data.result == 0) {
              this.msg2(this.$t('cateringDetail_cancel_success'))
              this.getData()
            } else {
              this.msg2(res.data.msg);
            }
          });
      },
      getData() {
        this.$http
          .get("/mobilepmsapi/reception/getPosResDetail/" + this.$route.query.id)
          .then(res => {
            if (res.data.result == 0) {
              this.order = res.data.retVal;
            } else {
              Toast({
                message: res.data.msg,
                position: "bottom",
                duration: 3000
              });
            }
          });
      }
    },
    filters: {
      datefomate(value) {
        return moment(value, "YYYY-MM-DD HH:mm:ss").format("MM/DD HH:mm");
      },
      dateF(value) {
        return value != null ? value.replace(/-/g, "/").substring(5, 10) : "";
      },
      intF(value) {
        return value != null && value != "" ? parseInt(value) : "";
      }
    },

    components: {}
  };
</script>
<style lang='less'>
  .cateringdetail {
    background-color: #f6f8f9;
    height: 100% !important;
    padding-bottom: 50px;
    box-sizing: border-box;

    .caterTop {
      margin: 0 20px;
      height: 26px;
      line-height: 26px;
      color: #333;
      margin-top: 10px;
      overflow: hidden;

      .left {
        float: left;

        span {
          margin-left: 5px;
        }
      }

      .right {
        float: right;

        span {
          color: #ffffff;
          font-weight: bold;
          font-size: 16px;
          border-radius: 12px;
          display: inline-block;
          width: 22px;
          height: 22px;
          text-align: center;
          background: #646f83;
          vertical-align: middle;
          line-height: 22px;
        }
      }
    }

    .infoList {
      width: 96%;
      margin: 10px auto;
      margin-bottom: 80px;
      box-sizing: border-box;
      background-color: #fff;
      padding-bottom: 80px;
      border-radius: 5px;
      box-shadow: 0 0.02666667rem 0.4rem #0006;

      .info {
        padding: 10px 0;

        .infoTop {
          padding: 0 18px;
          position: relative;
          height: 20px;
          line-height: 20px;

          .icon-changfangxingbiaoqian {
            position: absolute;
            font-size: 12px;
            left: 0;
            top: 1px;
            color: #f6a624;
          }
        }

        .infoContent {
          margin: 0 20px;
          padding: 10px 0;
          border-bottom: 1px dashed #ddd;

          li {
            height: 20px;
            line-height: 20px;

            .infoVal {
              margin-left: 8px;
            }

            &.twocol {
              width: 50%;
              float: left;
            }
          }

          &.twocol {
            overflow: hidden;

            li {
              width: 50%;
              float: left;
            }
          }
        }

        .totalmoney {
          margin: 0 20px;
          height: 30px;
          line-height: 30px;
          border-bottom: 1px dashed #ddd;

          span {
            margin-left: 20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// cateringDetail.vue?50611a84